import { APIInferenceSuggestionResult } from '@ardoq/api-types';
import { deleteEntity, fetchJson, headers } from './api';
import { ApiResponse } from './types';

const fetchSuggestion = async (): ApiResponse<APIInferenceSuggestionResult> => {
  const request = new Request('/api/inference/suggestion', { headers });
  return fetchJson<APIInferenceSuggestionResult>(request);
};

export const inferenceApi = {
  delete: deleteEntity('inference'),
  fetchSuggestion,
};
